import { Mic, Paperclip, SendHorizonal, Square } from "lucide-react";
import { AionLogoArtwork } from "@/components/aion/AionLogoArtwork";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const UniversalActionBar = ({
  actionLabel,
  audioFileInputRef,
  variant = "full",
  placement = "fixed",
  onAudioFileSelected,
  onOpenAudioPicker,
  onStopOutput,
  onSubmit,
  onVoiceCommandChange,
  onVoiceRecording,
  pending,
  recording,
  value,
  voiceDisplayState,
  voiceInputMode,
  voiceState,
  voiceCaptureSupported = true,
  voiceMicrophonePolicyBlocked = false,
}) => {
  const canStop = ["SPEAKING", "LISTENING", "SPEECH_DETECTED", "TRANSCRIBING", "THINKING", "RESPONDING", "EXECUTING"].includes(voiceState);
  const compact = variant === "compact";

  return (
  <div className={`aion-action-bar-wrap aion-action-bar-wrap-${placement}`} data-testid="universal-action-bar-wrap">
    <form
      className={`aion-action-bar aion-action-bar-${variant}`}
      onSubmit={(event) => {
        event.preventDefault();
        void onSubmit();
      }}
      data-testid="universal-action-bar"
    >
      <div className="aion-action-bar-copy" data-testid="universal-action-bar-copy">
        <span className="aion-action-bar-badge" data-testid="universal-action-bar-badge">
          <AionLogoArtwork
            variant="compact"
            className="aion-action-badge-logo-wrap"
            imageClassName="aion-action-badge-logo"
            dataTestId="action-bar-compact-logo"
          />
          {actionLabel}
        </span>
      </div>

      <Input
        value={value}
        onChange={(event) => onVoiceCommandChange(event.target.value)}
        placeholder="AION, was ist heute wichtig?"
        className={`aion-action-input aion-action-input-${variant}`}
        data-testid="voice-command-input"
      />

      <div className="aion-action-buttons" data-testid="universal-action-buttons">
        <Button
          type="button"
          variant={recording ? "secondary" : "outline"}
          onClick={onVoiceRecording}
          disabled={pending || (!recording && (!voiceCaptureSupported || voiceMicrophonePolicyBlocked))}
          aria-disabled={pending || (!recording && (!voiceCaptureSupported || voiceMicrophonePolicyBlocked))}
          title={!recording && voiceMicrophonePolicyBlocked
            ? "Mikrofon ist im Trust Center gesperrt."
            : !recording && !voiceCaptureSupported
              ? "Mikrofonaufnahme wird von diesem Browser nicht unterstützt."
              : undefined}
          data-testid="voice-record-toggle-button"
        >
          <Mic className="aion-button-icon" aria-hidden="true" />
          <span className="aion-action-label-full">{recording ? "Stoppen" : voiceMicrophonePolicyBlocked ? "Mic gesperrt" : voiceCaptureSupported ? "Mikrofon" : "Mic nicht verfügbar"}</span>
          <span className="aion-action-label-short">{recording ? "Stop" : voiceMicrophonePolicyBlocked ? "Lock" : voiceCaptureSupported ? "Mic" : "—"}</span>
        </Button>

        {!compact ? (
          <Button type="button" variant="outline" onClick={onOpenAudioPicker} disabled={pending} data-testid="voice-audio-upload-button">
            <Paperclip className="aion-button-icon" aria-hidden="true" />
            <span className="aion-action-label-full">Sprachmemo</span>
            <span className="aion-action-label-short">Memo</span>
          </Button>
        ) : null}

        <Button type="submit" disabled={pending || !value.trim()} data-testid="voice-command-submit-button">
          <SendHorizonal className="aion-button-icon" aria-hidden="true" />
          <span className="aion-action-label-full">{pending ? "AION antwortet…" : "Senden"}</span>
          <span className="aion-action-label-short">{pending ? "…" : "Send"}</span>
        </Button>

        {(!compact || canStop) ? (
          <Button type="button" variant="outline" onClick={onStopOutput} disabled={!canStop} data-testid="voice-stop-output-button">
            <Square className="aion-button-icon" aria-hidden="true" />
            <span className="aion-action-label-full">Stopp</span>
            <span className="aion-action-label-short">Stop</span>
          </Button>
        ) : null}
      </div>

      {!compact ? (
        <input
          ref={audioFileInputRef}
          type="file"
          accept="audio/*"
          capture={voiceMicrophonePolicyBlocked ? undefined : "user"}
          className="aion-hidden-audio-input"
          onChange={onAudioFileSelected}
          data-testid="voice-audio-input"
        />
      ) : null}
      <div className="aion-action-status" data-testid="universal-action-bar-status">
        Aktiver Modus: {voiceInputMode === "recording" ? "Mikrofonaufnahme" : voiceInputMode === "upload" ? "Sprachmemo" : voiceInputMode === "wake-word" ? "Wake-Word" : "Text"} · Status: {voiceDisplayState || "BEREIT"}
      </div>
    </form>
  </div>
  );
};